import { useCallback, useMemo } from 'react';

import { stripProtocol } from '@/lib/scheduling/buildBookingUrl';
import { SlugAvailabilityField } from '@/lib/scheduling/SlugAvailabilityField';
import { useBookingLinkBaseUrl } from '@/lib/scheduling/useBookingLinkBaseUrl';
import type { SlugStatus } from '@/lib/scheduling/useSlugAvailability';

interface GlobalSlugFieldProps {
  value: unknown;
  onChange: (next: unknown) => void;
  onStatusChange?: (status: SlugStatus) => void;
  disabled: boolean;
  'aria-label'?: string;
  /** Org ID used to resolve the booking-link domain for the prefix display. */
  orgId?: number | null;
}

export function GlobalSlugField({
  value,
  onChange,
  onStatusChange,
  disabled,
  'aria-label': ariaLabel,
  orgId,
}: GlobalSlugFieldProps) {
  const handleChange = useCallback(
    (next: string) => onChange(next),
    [onChange]
  );

  const { baseUrl } = useBookingLinkBaseUrl(orgId);
  const domainPrefix = useMemo(() => {
    const url = baseUrl ?? window.location.origin;
    return `${stripProtocol(url)}/`;
  }, [baseUrl]);

  return (
    <SlugAvailabilityField
      value={String(value ?? '')}
      onChange={handleChange}
      onStatusChange={onStatusChange}
      disabled={disabled}
      domainPrefix={domainPrefix}
      aria-label={ariaLabel}
    />
  );
}
